import { useState, useEffect } from "react";
import logger from "../../../util/logger";

import { v4 as uuidv4 } from "uuid";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import classnames from "classnames";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaCheck, FaChevronLeft } from "react-icons/fa";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";
import { IoMdAddCircle } from "react-icons/io";

import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import Avatar from "../../../components/Avatar/Avatar";

import emailjs from "@emailjs/browser";

function FriendsPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0].data();

      setUserData(data);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const [friends, setFriends] = useState();
  const [sentFriendRequests, setSentFriendRequests] = useState();
  const [receivedFriendRequests, setReceivedFriendRequests] = useState();

  const fetchUserRelationships = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "userRelationships"),
        where("users", "array-contains", user?.uid),
      );
      const doc = await getDocs(q);
      const data = doc.docs.map((doc) => doc.data());

      let userFriends = data.filter(
        (relationship) => relationship.status === "accepted",
      );
      userFriends = userFriends.map((friend) => {
        if (friend.firstUserUid === user.uid) {
          return {
            uid: friend.secondUserUid,
            username: friend.secondUserUsername,
            avatar: friend.secondUserAvatar,
            status: friend.status,
            relationshipUid: friend.uid,
          };
        } else {
          return {
            uid: friend.firstUserUid,
            username: friend.firstUserUsername,
            avatar: friend.firstUserAvatar,
            status: friend.status,
            relationshipUid: friend.uid,
          };
        }
      });

      await userFriends.forEach(async (friend) => {
        setIsLoading(true);

        const q = query(
          collection(db, "users"),
          where("uid", "==", friend.uid),
        );
        const doc = await getDocs(q);
        const data = doc.docs[0].data();
        friend.test = data.avatar;

        setIsLoading(false);
      });

      setFriends(userFriends);

      const userSentFriendRequests = data.filter(
        (relationship) =>
          relationship.status === "requested" &&
          relationship.firstUserUid === user.uid,
      );
      setSentFriendRequests(userSentFriendRequests);

      const userReceivedFriendRequests = data.filter(
        (relationship) =>
          relationship.status === "requested" &&
          relationship.secondUserUid === user.uid,
      );
      setReceivedFriendRequests(userReceivedFriendRequests);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserRelationships();
    }
    // eslint-disable-next-line
  }, [user]);

  const [usernameToSearch, setUsernameToSearch] = useState("");

  const [userSearchResult, setUserSearchResult] = useState();

  const [addFriendModalIsVisible, setAddFriendModalIsVisible] = useState(false);
  const toggleAddFriendModal = () => {
    setAddFriendModalIsVisible(!addFriendModalIsVisible);
    if (addFriendModalIsVisible) {
      setUsernameToSearch("");
      setUserSearchResult(null);
    }
  };

  const searchUser = async () => {
    if (!userData) {
      Swal.fire({
        text: "User data is still loading. Please try again.",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }

    if (usernameToSearch === userData.username) {
      Swal.fire({
        text: "You can't add yourself as a friend.",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      toggleAddFriendModal();
      setUsernameToSearch("");
    } else {
      try {
        setIsLoading(true);

        const q = query(
          collection(db, "users"),
          where("username", "==", usernameToSearch),
        );
        const doc = await getDocs(q);
        if (doc.docs.length > 0) {
          const data = doc.docs[0].data();
          setUserSearchResult(data);
        } else {
          Swal.fire({
            text: "No user found with that username. Please try another.",
            icon: "error",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });
          toggleAddFriendModal();
          setUsernameToSearch("");
        }

        setIsLoading(false);
      } catch (err) {
        console.error(err);
        alert("An error occured while fetching user data");
      }
    }
  };

  const sendFriendRequest = async () => {
    try {
      setIsLoading(true);

      const newUserRelationship = {
        uid: uuidv4(),
        users: [userData.uid, userSearchResult.uid],
        firstUserUid: userData.uid,
        firstUserUsername: userData.username,
        firstUserAvatar: userData.avatar || "",
        secondUserUid: userSearchResult.uid,
        secondUserUsername: userSearchResult.username,
        secondUserAvatar: userSearchResult.avatar || "",
        status: "requested",
      };

      await addDoc(collection(db, "userRelationships"), newUserRelationship);

      Swal.fire({
        text: "Friend request sent successfully!",
        icon: "success",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });

      // Send in-app notification
      const newNotification = {
        uid: uuidv4(),
        title: "Friend Request",
        description: `${userData.username} has sent you a friend request.`,
        recipientUid: userSearchResult.uid,
        dateCreated: new Date().toISOString(),
        isRead: false,
      };
      await addDoc(collection(db, "notifications"), newNotification);
      //

      // Send email notification
      const serviceId = "sportleague_outlook";
      const templateId = "friendRequest";
      const publicKey = "Ki5BETKiWrS6RDEP_";

      const templateParams = {
        toEmail: userSearchResult.email,
        toUsername: userSearchResult.username,
        fromUsername: userData.username,
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey).then(
        (response) => {
          logger.info("SUCCESS!", response.status, response.text);
        },
        (error) => {
          logger.error("FAILED...", error);
        },
      );
      //

      fetchUserRelationships();
      toggleAddFriendModal();
      setUsernameToSearch("");
      setUserSearchResult(null);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  // const addFriend = async () => {
  //   try {
  //     setIsLoading(true);

  //     let userFriends = friends;
  //     userFriends.push({
  //       uid: userSearchResult.uid,
  //       username: userSearchResult.username,
  //       avatar: userSearchResult.avatar,
  //       status: userSearchResult.status
  //     });

  //     const q = query(collection(db, "users"), where("uid", "==", user.uid));
  //     const findUsers = await getDocs(q);
  //     findUsers.forEach( async (userObject) => {
  //       const getUser = doc(db, 'users', userObject.id);
  //       await updateDoc(getUser, {
  //         friends: userFriends
  //       });
  //     });

  //     Swal.fire({
  //       text: "Friend added successfully!",
  //       icon: 'success',
  //       confirmButtonColor: '#005EE1',
  //       confirmButtonText: "OKAY",
  //     })

  //     toggleAddFriendModal();
  //     setUsernameToSearch('');
  //     setUserSearchResult(null);
  //     fetchUserData();

  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //     alert("An error occured while fetching user data");
  //   }
  // };

  const [activeTab, setActiveTab] = useState("FRIENDS LIST");
  const toggleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const cancelFriendRequest = async (friendRequest) => {
    console.log(friendRequest);
    Swal.fire({
      text: "Are you sure you want to cancel this friend request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, CANCEL",
      cancelButtonText: "NO, KEEP IT",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const requestRef = query(
            collection(db, "userRelationships"),
            where("uid", "==", friendRequest.uid),
          );
          const findRequests = await getDocs(requestRef);
          findRequests.forEach(async (requestObject) => {
            const getRequests = doc(db, "userRelationships", requestObject.id);
            await deleteDoc(getRequests);
          });

          Swal.fire({
            text: "Friend request cancelled successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchUserRelationships();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting news article");
        }
      }
    });
  };

  const acceptFriendRequest = async (friendRequest) => {
    Swal.fire({
      text: "Are you sure you want to accept this friend request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, ACCEPT",
      cancelButtonText: "NO, KEEP IT",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const requestRef = query(
            collection(db, "userRelationships"),
            where("uid", "==", friendRequest.uid),
          );
          const findRequests = await getDocs(requestRef);
          findRequests.forEach(async (requestObject) => {
            const getRequests = doc(db, "userRelationships", requestObject.id);
            await updateDoc(getRequests, {
              status: "accepted",
            });
          });

          Swal.fire({
            text: "Friend request accepted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchUserRelationships();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting news article");
        }
      }
    });
  };

  const rejectFriendRequest = async (friendRequest) => {
    Swal.fire({
      text: "Are you sure you want to reject this friend request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, REJECT",
      cancelButtonText: "NO, KEEP IT",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const requestRef = query(
            collection(db, "userRelationships"),
            where("uid", "==", friendRequest.uid),
          );
          const findRequests = await getDocs(requestRef);
          findRequests.forEach(async (requestObject) => {
            const getRequests = doc(db, "userRelationships", requestObject.id);
            await deleteDoc(getRequests);
          });

          Swal.fire({
            text: "Friend request rejected successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchUserRelationships();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting news article");
        }
      }
    });
  };

  const removeFriend = async (e, friend) => {
    e.stopPropagation();

    Swal.fire({
      text: "Are you sure you want to remove this friend?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, REMOVE",
      cancelButtonText: "NO, KEEP IT",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const requestRef = query(
            collection(db, "userRelationships"),
            where("uid", "==", friend.relationshipUid),
          );
          const findRequests = await getDocs(requestRef);
          findRequests.forEach(async (requestObject) => {
            const getRequests = doc(db, "userRelationships", requestObject.id);
            await deleteDoc(getRequests);
          });

          Swal.fire({
            text: "Friend removed successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchUserRelationships();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting news article");
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="friendsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("friends").toUpperCase()}
        <span>{/* {friends?.length ? friends?.length : 0} */}</span>
      </h1>
      <div>
        <ScrollMenu>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeTab === "FRIENDS LIST",
            })}
            onClick={() => toggleActiveTab("FRIENDS LIST")}
          >
            <p>FRIENDS LIST</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeTab === "FRIEND REQUESTS",
            })}
            onClick={() => toggleActiveTab("FRIEND REQUESTS")}
          >
            <p>FRIEND REQUESTS</p>
          </div>
        </ScrollMenu>
        <Button
          onClick={toggleAddFriendModal}
          className="primaryBtn"
          style={{ marginBottom: "1rem", marginTop: "0.5rem" }}
        >
          {t("addFriend").toUpperCase()}
        </Button>
        <Modal
          id="serviceSelectModal"
          isOpen={addFriendModalIsVisible}
          toggle={toggleAddFriendModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleAddFriendModal} />
            </div>
            <div>
              <h1>{t("addFriend").toUpperCase()}</h1>
              <div style={{ marginTop: "1rem" }}>
                <Input
                  type="text"
                  className="authInput"
                  value={usernameToSearch}
                  onChange={(e) => setUsernameToSearch(e.target.value)}
                  placeholder={t("theUsersUsername")}
                  style={{ marginBottom: "1rem" }}
                />
                <Button onClick={searchUser} className="primaryBtn">
                  {t("search").toUpperCase()}
                </Button>
                {userSearchResult && (
                  <div className="friendsPageSearchResultContainer">
                    <Avatar
                      src={userSearchResult.avatar}
                      size={48}
                      user={userSearchResult}
                    />
                    <div>
                      <p className="userName">{userSearchResult.username}</p>
                      <p className="userStatus">{userSearchResult.status}</p>
                    </div>
                    <IoMdAddCircle onClick={sendFriendRequest} />
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
        {activeTab === "FRIENDS LIST" ? (
          <div>
            {friends?.length > 0 ? (
              friends?.map((friend) => {
                console.log(friend);
                return (
                  <div
                    onClick={() => navigate(`${friend.username}`)}
                    className="friendsPageFriendContainer"
                  >
                    <Avatar src={friend?.test} size={48} user={friend} />
                    <div>
                      <p className="friendName">{friend.username}</p>
                      <div style={{ justifyContent: "end" }}>
                        <IoClose
                          onClick={(e) => removeFriend(e, friend)}
                          style={{
                            color: "red",
                            width: 30,
                            height: 30,
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginTop: "1rem",
                  marginBottom: 0,
                }}
              >
                {t("noFriends")}
              </p>
            )}
          </div>
        ) : activeTab === "FRIEND REQUESTS" ? (
          <div>
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              {t("sent")}
            </p>
            {sentFriendRequests?.length > 0 ? (
              sentFriendRequests?.map((friendRequest) => {
                return (
                  <div className="friendsPageFriendContainer">
                    <Avatar
                      src={friendRequest.secondUserAvatar}
                      size={48}
                      user={{ avatar: friendRequest.secondUserAvatar }}
                    />
                    <div>
                      <p className="friendName">
                        {friendRequest.secondUserUsername}
                      </p>
                      <IoClose
                        onClick={() => cancelFriendRequest(friendRequest)}
                        style={{
                          color: "red",
                          width: 30,
                          height: 30,
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
                <p
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    marginBottom: 0,
                  }}
                >
                  {t("noSentRequests")}
                </p>
              </div>
            )}
            <p
              className="inputLabel"
              style={{ color: "#FFFFFF", marginTop: "1rem" }}
            >
              {t("received")}
            </p>
            {receivedFriendRequests?.length > 0 ? (
              receivedFriendRequests?.map((friendRequest) => {
                return (
                  <div className="friendsPageFriendContainer">
                    <Avatar
                      src={friendRequest.firstUserAvatar}
                      size={48}
                      user={{ avatar: friendRequest.firstUserAvatar }}
                    />
                    <div>
                      <p className="friendName">
                        {friendRequest.firstUserUsername}
                      </p>
                      <div style={{ justifyContent: "end" }}>
                        <FaCheck
                          onClick={() => acceptFriendRequest(friendRequest)}
                          style={{
                            color: "#25D366",
                            width: 25,
                            height: 25,
                            marginRight: "1rem",
                            cursor: "pointer",
                          }}
                        />
                        <IoClose
                          onClick={() => rejectFriendRequest(friendRequest)}
                          style={{
                            color: "red",
                            width: 30,
                            height: 30,
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ marginTop: "1rem" }}>
                <p
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    marginTop: "1rem",
                    marginBottom: 0,
                  }}
                >
                  {t("noReceivedRequests")}
                </p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default FriendsPage;
